// @flow
import type { Errors } from 'types/errors';
import type { RequestStates } from 'types/redux';

import React, { Component, PropTypes } from 'react';
import { loginWithConcedo } from 'actions/app';
import { connect } from 'react-redux';

import _ from 'lodash';

type Props = {
  user: {
    concedoToken: string,
  },
  userLogin: Function,
  loginRequest: RequestStates,
  loginErrors: Errors,
  location: Object,
};

export class ConcedoCallbackPage extends Component {
  componentDidMount() {
    const { location, userLogin } = this.props;
    const { query } = location;
    if (query && query.code) {
      userLogin(query.code);
    }
  }

  componentWillReceiveProps(nextProps: Props) {
    const user = nextProps.user;
    if (user.concedoToken) {
      this.context.router.push('/app');
    }
  }

  props: Props;

  render() {
    return (
      <div style={{ height: '100vh', textAlign: 'center', color: '#3e3e3e' }}>
        <div style={{ fontSize: '50px', fontWeight: 'bold', padding: '300px 0' }}>
          AUTHENTICATING...
        </div>
      </div>
    );
  }
}

ConcedoCallbackPage.contextTypes = {
  router: PropTypes.object.isRequired,
};

function mapStateToProps(state) {
  return {
    user: state.app.user || {},
    loginRequest: state.requests.loginWithConcedoRequest || {},
    loginErrors: _.get(state.errors, 'loginWithConcedo.errors', []),
  };
}

export default connect(
  mapStateToProps,
  {
    userLogin: loginWithConcedo,
  }
)(ConcedoCallbackPage);



/** WEBPACK FOOTER **
 ** ./src/js/views/auth/ConcedoCallbackPage.jsx
 **/